"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLayoutOneColumn = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helperFunctions = require("../../../../styles/helperFunctions");

var _layout = require("../../../../styles/2_commonComponentStyles/layout");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// todo: remove when ie11 becomes unsupported
var IE11StyledLayoutOneColumn = _styledComponents.default.div.withConfig({
  displayName: "LayoutOneColstyles__IE11StyledLayoutOneColumn",
  componentId: "sc-1r4ozgm-0"
})(["display:-ms-grid;-ms-grid-columns:1fr ", " 1fr;-ms-grid-rows:auto auto auto auto auto;", ";.c-layout-one-col-header{position:relative;-ms-grid-row:1;-ms-grid-column:1;-ms-grid-column-span:3;}.c-layout-one-col-progress-bar{position:relative;-ms-grid-row:2;-ms-grid-column:1;-ms-grid-column-span:3;}.c-layout-one-col-nav-area{-ms-grid-row:3;-ms-grid-column:2;}.c-layout-one-col-content{-ms-grid-row:4;-ms-grid-column:2;}.c-layout-one-col-footer{-ms-grid-row:5;-ms-grid-column:2;}"], function (props) {
  return props.theme.componentSizeLarge;
}, _layout.layoutThemes);

var StyledLayoutOneColumn = (0, _styledComponents.default)(IE11StyledLayoutOneColumn).withConfig({
  displayName: "LayoutOneColstyles__StyledLayoutOneColumn",
  componentId: "sc-1r4ozgm-1"
})(["margin:0 auto;position:relative;.c-layout-one-col-header{width:100%;z-index:", ";}.c-layout-one-col-progress-bar{width:100%;z-index:", ";}.c-layout-one-col-nav-area{align-items:center;display:flex;overflow:hidden;padding-top:.5rem;}.c-layout-one-col-content{}.c-layout-one-col-blur,.c-layout-one-col-blur *{opacity:0.4;filter:blur(3px);}.c-layout-one-col-footer{min-height:", ";height:", ";}@supports (display:grid){&{display:grid;grid-template-columns:minmax(", ",1fr) minmax(", ",", ") minmax(", ",1fr);grid-template-areas:\"hd hd hd\" \"shd shd shd\" \". nav .\" \". ct .\" \". ft .\";@media only screen and (min-width:", "){grid-template-columns:1fr max(", ") 1fr;}}.c-layout-one-col-header{grid-area:hd;position:fixed;top:0;@media only screen and (min-width:", "){position:relative;}&.c-layout-one-col-remove-fixed{position:relative;}}.c-layout-one-col-progress-bar{grid-area:shd;position:fixed;top:", ";@media only screen and (min-width:", "){position:relative;top:0;}&.c-layout-one-col-remove-fixed{position:relative;top:0;}}.c-layout-one-col-nav-area{grid-area:nav;margin-top:", ";@media only screen and (min-width:", "){margin-top:0;}&.c-layout-one-col-remove-fixed{margin-top:0;}}.c-layout-one-col-content{grid-area:ct;}.c-layout-one-col-footer{grid-area:ft;}}"], function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.menu, 10);
}, function (props) {
  return props.theme.menu;
}, function (props) {
  return props.theme.footerHeight;
}, function (props) {
  return props.theme.footerHeight;
}, function (props) {
  return props.theme.mobileGutter;
}, function (props) {
  return props.theme.mobilMinContent;
}, function (props) {
  return props.theme.componentSizeLarge;
}, function (props) {
  return props.theme.mobileGutter;
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return props.theme.componentSizeLarge;
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return props.theme.mobileMenuHeight;
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.mobileMenuHeight, props.theme.progressBarHeight);
}, function (props) {
  return props.theme.smallBreak;
});
exports.StyledLayoutOneColumn = StyledLayoutOneColumn;